(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CustomStickerApp = undefined;

var _htmlToImage = require('html-to-image');

var htmlToImage = _interopRequireWildcard(_htmlToImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var CONFIG = {
    title: {
        maxLines: 3,
        maxLineLength: 13,
        get maxTotalLength() {
            return this.maxLines * this.maxLineLength;
        }
    },
    message: {
        maxLines: 2,
        maxLineLength: 32,
        get maxTotalLength() {
            return this.maxLines * this.maxLineLength;
        }
    }
};

var SELECTORS = {
    sidebar: '.js-custom-sticker-sidebar',
    slideOut: '.js-slide-out',
    body: '.js-body',
    cartSidebar: '.js-cart-sidebar',
    preview: {
        wrapper: '.js-custom-sticker-product-page-preview',
        message: '.js-custom-sticker-message-preview',
        title: '.js-custom-sticker-title-preview',
        image: '.custom-sticker-preview__image'
    },
    form: '.js-custom-sticker-form',
    content: '.js-custom-sticker-content',
    widgets: {
        main: '.js-custom-sticker-widget',
        alreadyExists: '.js-custom-sticker-already'
    },
    counters: {
        message: '.js-custom-sticker-message-counter',
        title: '.js-custom-sticker-title-counter'
    },
    inputs: {
        message: '.js-custom-sticker-message',
        title: '.js-custom-sticker-title',
        inputs: '.js-custom-sticker-input',
        messageHTML: '.js-custom-message-html',
        titleHTML: '.js-custom-title-html'
    }
};

var UIController = {
    showSidebar: function showSidebar() {
        var sidebar = document.querySelector(SELECTORS.sidebar);
        var slideOut = document.querySelector(SELECTORS.slideOut);
        var body = document.querySelector(SELECTORS.body);

        if (sidebar && slideOut) {
            sidebar.style.width = null;
            slideOut.classList.add('slide-out--is-open');
            body.classList.add('overflow-hidden');
        }
    },
    closeSidebar: function closeSidebar() {
        var sidebar = document.querySelector(SELECTORS.sidebar);
        var slideOut = document.querySelector(SELECTORS.slideOut);
        var body = document.querySelector(SELECTORS.body);
        var cartSidebarIsOpen = document.querySelector(SELECTORS.cartSidebar).offsetWidth > 0;

        if (sidebar.style.width !== '0px') {
            sidebar.style.width = '0px';
            if (!cartSidebarIsOpen) {
                slideOut.classList.remove('slide-out--is-open');
                body.classList.remove('overflow-hidden');
            }
        }
    },
    processText: function processText(text, config) {
        var maxLines = config.maxLines,
            maxLineLength = config.maxLineLength;


        var words = text.split(' ').filter(function (word) {
            return word.length > 0;
        });

        var formattedLines = [];
        var currentLine = '';

        for (var i = 0; i < words.length; i++) {
            var currentWord = words[i];

            var safeWord = currentWord.substring(0, maxLineLength);

            if (currentLine.length === 0) {
                currentLine = safeWord;
            } else if (currentLine.length + safeWord.length + 1 <= maxLineLength) {
                currentLine += ' ' + safeWord;
            } else {
                formattedLines.push(currentLine);
                currentLine = safeWord;

                if (formattedLines.length >= maxLines - 1) {

                    var lastLineSpace = maxLineLength - currentLine.length;

                    for (var j = i + 1; j < words.length; j++) {
                        var nextWord = words[j];

                        if (lastLineSpace >= nextWord.length + 1) {
                            currentLine += ' ' + nextWord;
                            lastLineSpace -= nextWord.length + 1;
                        } else if (lastLineSpace > 1) {
                            currentLine += ' ' + nextWord.substring(0, lastLineSpace - 1);
                            break;
                        } else {
                            break;
                        }
                    }
                    break;
                }
            }
        }

        if (currentLine.length > 0 && formattedLines.length < maxLines) {
            formattedLines.push(currentLine);
        }

        return formattedLines;
    },


    sanitizeInput: function sanitizeInput(text) {
        // Prohibit pipes
        var sanitized = text.replace(/\|/g, '');
        sanitized = sanitized.replace(/[´`]/g, "'");

        // Prohibit non latin caracter
        sanitized = sanitized.replace(/[^A-Za-zÀ-ÖØ-öø-ÿĀ-ſƀ-ɏ0-9\s.,;:!?'’"()\-–—]/g, '');

        // Prohibit emojis
        sanitized = sanitized.replace(/(\u00a9|\u00ae|[\u2000-\u2018\u201A-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g, '');
        return sanitized;
    },

    updatePreview: function updatePreview() {
        var titleInput = document.querySelector(SELECTORS.inputs.title);
        var messageInput = document.querySelector(SELECTORS.inputs.message);
        var titlePreview = document.querySelector(SELECTORS.preview.title);
        var messagePreview = document.querySelector(SELECTORS.preview.message);
        var titleHTML = document.querySelector(SELECTORS.inputs.titleHTML);
        var messageHTML = document.querySelector(SELECTORS.inputs.messageHTML);

        var processedTitleLines = UIController.processText(titleInput.value, CONFIG.title).join('<br />');
        titlePreview.innerHTML = processedTitleLines;
        titleHTML.value = processedTitleLines;

        var processedMessageLines = UIController.processText(messageInput.value, CONFIG.message).join('<br />');
        messagePreview.innerHTML = processedMessageLines;
        messageHTML.value = processedMessageLines;
    },
    updateCounter: function updateCounter(type) {
        var preview = document.querySelector(SELECTORS.preview[type]);
        var counter = document.querySelector(SELECTORS.counters[type]);
        var _CONFIG$type = CONFIG[type],
            maxTotalLength = _CONFIG$type.maxTotalLength,
            maxLineLength = _CONFIG$type.maxLineLength;


        var value = preview.innerHTML;
        var lines = [];
        var totalLength = 0;

        if (value) {
            lines = value.split(/<br\s*\/?>/gi);
            var lastPartLength = lines.length > 0 ? lines[lines.length - 1].length : 0;
            totalLength = (lines.length - 1) * maxLineLength + lastPartLength;
        }

        counter.textContent = totalLength + '/' + maxTotalLength;

        var color = '#666';
        if (totalLength >= maxTotalLength) {
            color = '#ff0000';
        } else if (totalLength >= maxTotalLength * 0.7) {
            color = '#ff9900';
        }
        counter.style.color = color;
    },
    updateCounters: function updateCounters() {
        this.updateCounter('message');
        this.updateCounter('title');
    }
};

var APIService = {
    getCustomSticker: function getCustomSticker(productId, stickerId) {
        return fetch('/get-custom-sticker?productId=' + productId + '&stickerId=' + stickerId).then(function (response) {
            return response.json();
        });
    },

    saveCustomSticker: function saveCustomSticker(formData) {
        return fetch('/save-custom-sticker', {
            method: 'POST',
            body: formData
        }).then(function (response) {
            return response.json();
        });
    }
};

var EventHandlers = {
    handleTextInput: function handleTextInput(event, config) {
        var input = event.target;
        var text = input.value;

        var sanitizedText = UIController.sanitizeInput(text);
        if (sanitizedText !== text) {
            input.value = sanitizedText;
            text = sanitizedText;
        }

        var processedLines = UIController.processText(text, config);
        var processedText = processedLines.join(' ');

        if (processedText.trim() !== text.trim()) {
            input.value = processedText;
        }

        UIController.updatePreview();
        UIController.updateCounters();
    },
    handleCustomStickerSelection: function handleCustomStickerSelection(event) {
        var previewWrapper = document.querySelector(SELECTORS.preview.wrapper);

        if (event.target.checked && previewWrapper.children.length === 0) {
            CustomStickerApp.showCustomStickerSidebar(event);
        }
    },
    handleFormSubmit: function handleFormSubmit(event) {
        event.preventDefault();
        var form = event.target;
        var formData = new FormData(form);
        var previewElement = document.querySelector('.custom-sticker__preview');
        var tempImage = void 0;

        var htmlToImageConfig = { cacheBust: true };
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            htmlToImageConfig = { cacheBust: true, skipFonts: true };
        }

        htmlToImage.toPng(previewElement, htmlToImageConfig).then(function (customStickerImage) {
            tempImage = customStickerImage;
            formData.append('custom_sticker[image]', customStickerImage);
            return APIService.saveCustomSticker(formData);
        }).then(function (data) {
            if (data.success) {
                UIController.closeSidebar();
                document.querySelectorAll(SELECTORS.preview.image).forEach(function (image) {
                    return image.src = tempImage;
                });
                document.querySelector(SELECTORS.preview.wrapper).innerHTML = data.message.preview;
            }
        }).catch(function (error) {
            return console.error('Error:', error);
        });
    }
};

var CustomStickerApp = exports.CustomStickerApp = {
    init: function init() {
        var _this = this;

        if (!window.customStickerInitialized) {
            document.addEventListener('DOMContentLoaded', function () {
                return _this.initializeSidebarControls();
            }, { once: true });
            window.customStickerInitialized = true;
        }
    },
    initializeAll: function initializeAll() {
        this.initializeCustomStickerInputs();
        UIController.updatePreview();
        UIController.updateCounters();
    },
    initializeSidebarControls: function initializeSidebarControls() {
        var _this2 = this;

        var closeButtons = document.querySelectorAll('.js-close-custom-sticker-sidebar');
        var options = document.querySelectorAll('.js-custom-sticker-option');
        var slideOut = document.querySelector(SELECTORS.slideOut);

        document.body.addEventListener('click', function (e) {
            var openButton = e.target.closest('.js-open-custom-sticker');
            if (openButton) {
                _this2.showCustomStickerSidebar({ currentTarget: openButton });
            }
        });

        // Display custom sticker sidebar when the user wants to add a product with a custom sticker that they haven't personalized yet
        document.addEventListener('click', function (event) {
            if (event.target.closest('.js-add-product-to-cart')) {
                var customStickerElement = document.querySelector('.js-custom-sticker-option');
                var isCustomStickerChecked = customStickerElement ? customStickerElement.checked : false;
                var previewContainer = document.querySelector('.js-custom-sticker-product-preview-container');

                if (isCustomStickerChecked && !previewContainer) {
                    event.preventDefault();
                    event.stopPropagation();

                    var openCustomStickerButton = document.querySelector('.js-open-custom-sticker');
                    if (openCustomStickerButton) {
                        _this2.showCustomStickerSidebar({ currentTarget: openCustomStickerButton });
                    }
                }
            }
        }, true);

        options.forEach(function (option) {
            return option.addEventListener('change', EventHandlers.handleCustomStickerSelection);
        });

        if (slideOut) {
            slideOut.addEventListener('click', UIController.closeSidebar);
        }

        closeButtons.forEach(function (button) {
            return button.addEventListener('click', UIController.closeSidebar);
        });
    },
    initializeCustomStickerInputs: function initializeCustomStickerInputs() {
        var inputs = document.querySelectorAll(SELECTORS.inputs.inputs);

        inputs.forEach(function (input) {
            var config = CONFIG[input.dataset.type];

            input.addEventListener('input', function (e) {
                return EventHandlers.handleTextInput(e, config);
            });
        });
    },
    showCustomStickerSidebar: function showCustomStickerSidebar(event) {
        var _this3 = this;

        var _event$currentTarget$ = event.currentTarget.dataset,
            stickerId = _event$currentTarget$.stickerId,
            _event$currentTarget$2 = _event$currentTarget$.productId,
            productId = _event$currentTarget$2 === undefined ? null : _event$currentTarget$2;


        APIService.getCustomSticker(productId, stickerId).then(function (data) {
            if (data.success) {
                if (data.message.hasAnotherCustomStickerInOrder) {
                    document.querySelector(SELECTORS.widgets.main).classList.add('hide');
                    document.querySelector(SELECTORS.preview.wrapper).classList.add('hide');
                    document.querySelector(SELECTORS.widgets.alreadyExists).classList.remove('hide');
                } else {
                    UIController.showSidebar();
                    document.querySelector(SELECTORS.content).innerHTML = data.message.sidebar;
                    _this3.initializeAll();

                    var form = document.querySelector(SELECTORS.form);
                    form.addEventListener('submit', EventHandlers.handleFormSubmit);
                }
            }
        }).catch(function (error) {
            return console.error('Error:', error);
        });
    }
};

CustomStickerApp.init();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
},{"html-to-image":10}],2:[function(require,module,exports){
// shim for using process in browser

var process = module.exports = {};

process.nextTick = (function () {
    var canSetImmediate = typeof window !== 'undefined'
    && window.setImmediate;
    var canPost = typeof window !== 'undefined'
    && window.postMessage && window.addEventListener
    ;

    if (canSetImmediate) {
        return function (f) { return window.setImmediate(f) };
    }

    if (canPost) {
        var queue = [];
        window.addEventListener('message', function (ev) {
            var source = ev.source;
            if ((source === window || source === null) && ev.data === 'process-tick') {
                ev.stopPropagation();
                if (queue.length > 0) {
                    var fn = queue.shift();
                    fn();
                }
            }
        }, true);

        return function nextTick(fn) {
            queue.push(fn);
            window.postMessage('process-tick', '*');
        };
    }

    return function nextTick(fn) {
        setTimeout(fn, 0);
    };
})();

process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
}

// TODO(shtylman)
process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};

},{}],3:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyStyle = void 0;
function applyStyle(node, options) {
    var style = node.style;
    if (options.backgroundColor) {
        style.backgroundColor = options.backgroundColor;
    }
    if (options.width) {
        style.width = "".concat(options.width, "px");
    }
    if (options.height) {
        style.height = "".concat(options.height, "px");
    }
    var manual = options.style;
    if (manual != null) {
        Object.keys(manual).forEach(function (key) {
            style[key] = manual[key];
        });
    }
    return node;
}
exports.applyStyle = applyStyle;
//# sourceMappingURL=apply-style.js.map
},{}],4:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneNode = void 0;
var clone_pseudos_1 = require("./clone-pseudos");
var util_1 = require("./util");
var mimes_1 = require("./mimes");
var dataurl_1 = require("./dataurl");
function cloneCanvasElement(canvas) {
    return __awaiter(this, void 0, void 0, function () {
        var dataURL;
        return __generator(this, function (_a) {
            dataURL = canvas.toDataURL();
            if (dataURL === 'data:,') {
                return [2 /*return*/, canvas.cloneNode(false)];
            }
            return [2 /*return*/, (0, util_1.createImage)(dataURL)];
        });
    });
}
function cloneVideoElement(video, options) {
    return __awaiter(this, void 0, void 0, function () {
        var canvas, ctx, dataURL_1, poster, contentType, dataURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (video.currentSrc) {
                        canvas = document.createElement('canvas');
                        ctx = canvas.getContext('2d');
                        canvas.width = video.clientWidth;
                        canvas.height = video.clientHeight;
                        ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                        dataURL_1 = canvas.toDataURL();
                        return [2 /*return*/, (0, util_1.createImage)(dataURL_1)];
                    }
                    poster = video.poster;
                    contentType = (0, mimes_1.getMimeType)(poster);
                    return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(poster, contentType, options)];
                case 1:
                    dataURL = _a.sent();
                    return [2 /*return*/, (0, util_1.createImage)(dataURL)];
            }
        });
    });
}
function cloneIFrameElement(iframe) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    if (!((_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) return [3 /*break*/, 2];
                    return [4 /*yield*/, cloneNode(iframe.contentDocument.body, {}, true)];
                case 1: return [2 /*return*/, (_c.sent())];
                case 2: return [3 /*break*/, 4];
                case 3:
                    _b = _c.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, iframe.cloneNode(false)];
            }
        });
    });
}
function cloneSingleNode(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ((0, util_1.isInstanceOfElement)(node, HTMLCanvasElement)) {
                return [2 /*return*/, cloneCanvasElement(node)];
            }
            if ((0, util_1.isInstanceOfElement)(node, HTMLVideoElement)) {
                return [2 /*return*/, cloneVideoElement(node, options)];
            }
            if ((0, util_1.isInstanceOfElement)(node, HTMLIFrameElement)) {
                return [2 /*return*/, cloneIFrameElement(node)];
            }
            return [2 /*return*/, node.cloneNode(isSVGElement(node))];
        });
    });
}
var isSlotElement = function (node) {
    return node.tagName != null && node.tagName.toUpperCase() === 'SLOT';
};
var isSVGElement = function (node) {
    return node.tagName != null && node.tagName.toUpperCase() === 'SVG';
};
function cloneChildren(nativeNode, clonedNode, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var children;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (isSVGElement(clonedNode)) {
                        return [2 /*return*/, clonedNode];
                    }
                    children = [];
                    if (isSlotElement(nativeNode) && nativeNode.assignedNodes) {
                        children = (0, util_1.toArray)(nativeNode.assignedNodes());
                    }
                    else if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLIFrameElement) &&
                        ((_a = nativeNode.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
                        children = (0, util_1.toArray)(nativeNode.contentDocument.body.childNodes);
                    }
                    else {
                        children = (0, util_1.toArray)(((_b = nativeNode.shadowRoot) !== null && _b !== void 0 ? _b : nativeNode).childNodes);
                    }
                    if (children.length === 0 ||
                        (0, util_1.isInstanceOfElement)(nativeNode, HTMLVideoElement)) {
                        return [2 /*return*/, clonedNode];
                    }
                    return [4 /*yield*/, children.reduce(function (deferred, child) {
                            return deferred
                                .then(function () { return cloneNode(child, options); })
                                .then(function (clonedChild) {
                                if (clonedChild) {
                                    clonedNode.appendChild(clonedChild);
                                }
                            });
                        }, Promise.resolve())];
                case 1:
                    _c.sent();
                    return [2 /*return*/, clonedNode];
            }
        });
    });
}
function cloneCSSStyle(nativeNode, clonedNode) {
    var targetStyle = clonedNode.style;
    if (!targetStyle) {
        return;
    }
    var sourceStyle = window.getComputedStyle(nativeNode);
    if (sourceStyle.cssText) {
        targetStyle.cssText = sourceStyle.cssText;
        targetStyle.transformOrigin = sourceStyle.transformOrigin;
    }
    else {
        (0, util_1.toArray)(sourceStyle).forEach(function (name) {
            var value = sourceStyle.getPropertyValue(name);
            if (name === 'font-size' && value.endsWith('px')) {
                var reducedFont = Math.floor(parseFloat(value.substring(0, value.length - 2))) - 0.1;
                value = "".concat(reducedFont, "px");
            }
            if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLIFrameElement) &&
                name === 'display' &&
                value === 'inline') {
                value = 'block';
            }
            if (name === 'd' && clonedNode.getAttribute('d')) {
                value = "path(".concat(clonedNode.getAttribute('d'), ")");
            }
            targetStyle.setProperty(name, value, sourceStyle.getPropertyPriority(name));
        });
    }
}
function cloneInputValue(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLTextAreaElement)) {
        clonedNode.innerHTML = nativeNode.value;
    }
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLInputElement)) {
        clonedNode.setAttribute('value', nativeNode.value);
    }
}
function cloneSelectValue(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(nativeNode, HTMLSelectElement)) {
        var clonedSelect = clonedNode;
        var selectedOption = Array.from(clonedSelect.children).find(function (child) { return nativeNode.value === child.getAttribute('value'); });
        if (selectedOption) {
            selectedOption.setAttribute('selected', '');
        }
    }
}
function decorate(nativeNode, clonedNode) {
    if ((0, util_1.isInstanceOfElement)(clonedNode, Element)) {
        cloneCSSStyle(nativeNode, clonedNode);
        (0, clone_pseudos_1.clonePseudoElements)(nativeNode, clonedNode);
        cloneInputValue(nativeNode, clonedNode);
        cloneSelectValue(nativeNode, clonedNode);
    }
    return clonedNode;
}
function ensureSVGSymbols(clone, options) {
    return __awaiter(this, void 0, void 0, function () {
        var uses, processedDefs, i, use, id, exist, definition, _a, _b, nodes, ns, svg, defs, i;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    uses = clone.querySelectorAll ? clone.querySelectorAll('use') : [];
                    if (uses.length === 0) {
                        return [2 /*return*/, clone];
                    }
                    processedDefs = {};
                    i = 0;
                    _c.label = 1;
                case 1:
                    if (!(i < uses.length)) return [3 /*break*/, 4];
                    use = uses[i];
                    id = use.getAttribute('xlink:href');
                    if (!id) return [3 /*break*/, 3];
                    exist = clone.querySelector(id);
                    definition = document.querySelector(id);
                    if (!(!exist && definition && !processedDefs[id])) return [3 /*break*/, 3];
                    // eslint-disable-next-line no-await-in-loop
                    _a = processedDefs;
                    _b = id;
                    return [4 /*yield*/, cloneNode(definition, options, true)];
                case 2:
                    // eslint-disable-next-line no-await-in-loop
                    _a[_b] = (_c.sent());
                    _c.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    nodes = Object.values(processedDefs);
                    if (nodes.length) {
                        ns = 'http://www.w3.org/1999/xhtml';
                        svg = document.createElementNS(ns, 'svg');
                        svg.setAttribute('xmlns', ns);
                        svg.style.position = 'absolute';
                        svg.style.width = '0';
                        svg.style.height = '0';
                        svg.style.overflow = 'hidden';
                        svg.style.display = 'none';
                        defs = document.createElementNS(ns, 'defs');
                        svg.appendChild(defs);
                        for (i = 0; i < nodes.length; i++) {
                            defs.appendChild(nodes[i]);
                        }
                        clone.appendChild(svg);
                    }
                    return [2 /*return*/, clone];
            }
        });
    });
}
function cloneNode(node, options, isRoot) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!isRoot && options.filter && !options.filter(node)) {
                return [2 /*return*/, null];
            }
            return [2 /*return*/, Promise.resolve(node)
                    .then(function (clonedNode) { return cloneSingleNode(clonedNode, options); })
                    .then(function (clonedNode) { return cloneChildren(node, clonedNode, options); })
                    .then(function (clonedNode) { return decorate(node, clonedNode); })
                    .then(function (clonedNode) { return ensureSVGSymbols(clonedNode, options); })];
        });
    });
}
exports.cloneNode = cloneNode;
//# sourceMappingURL=clone-node.js.map
},{"./clone-pseudos":5,"./dataurl":6,"./mimes":11,"./util":12}],5:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clonePseudoElements = void 0;
var util_1 = require("./util");
function formatCSSText(style) {
    var content = style.getPropertyValue('content');
    return "".concat(style.cssText, " content: '").concat(content.replace(/'|"/g, ''), "';");
}
function formatCSSProperties(style) {
    return (0, util_1.toArray)(style)
        .map(function (name) {
        var value = style.getPropertyValue(name);
        var priority = style.getPropertyPriority(name);
        return "".concat(name, ": ").concat(value).concat(priority ? ' !important' : '', ";");
    })
        .join(' ');
}
function getPseudoElementStyle(className, pseudo, style) {
    var selector = ".".concat(className, ":").concat(pseudo);
    var cssText = style.cssText
        ? formatCSSText(style)
        : formatCSSProperties(style);
    return document.createTextNode("".concat(selector, "{").concat(cssText, "}"));
}
function clonePseudoElement(nativeNode, clonedNode, pseudo) {
    var style = window.getComputedStyle(nativeNode, pseudo);
    var content = style.getPropertyValue('content');
    if (content === '' || content === 'none') {
        return;
    }
    var className = (0, util_1.uuid)();
    try {
        clonedNode.className = "".concat(clonedNode.className, " ").concat(className);
    }
    catch (err) {
        return;
    }
    var styleElement = document.createElement('style');
    styleElement.appendChild(getPseudoElementStyle(className, pseudo, style));
    clonedNode.appendChild(styleElement);
}
function clonePseudoElements(nativeNode, clonedNode) {
    clonePseudoElement(nativeNode, clonedNode, ':before');
    clonePseudoElement(nativeNode, clonedNode, ':after');
}
exports.clonePseudoElements = clonePseudoElements;
//# sourceMappingURL=clone-pseudos.js.map
},{"./util":12}],6:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resourceToDataURL = exports.fetchAsDataURL = exports.makeDataUrl = exports.isDataUrl = void 0;
function getContentFromDataUrl(dataURL) {
    return dataURL.split(/,/)[1];
}
function isDataUrl(url) {
    return url.search(/^(data:)/) !== -1;
}
exports.isDataUrl = isDataUrl;
function makeDataUrl(content, mimeType) {
    return "data:".concat(mimeType, ";base64,").concat(content);
}
exports.makeDataUrl = makeDataUrl;
function fetchAsDataURL(url, init, process) {
    return __awaiter(this, void 0, void 0, function () {
        var res, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch(url, init)];
                case 1:
                    res = _a.sent();
                    if (res.status === 404) {
                        throw new Error("Resource \"".concat(res.url, "\" not found"));
                    }
                    return [4 /*yield*/, res.blob()];
                case 2:
                    blob = _a.sent();
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var reader = new FileReader();
                            reader.onerror = reject;
                            reader.onloadend = function () {
                                try {
                                    resolve(process({ res: res, result: reader.result }));
                                }
                                catch (error) {
                                    reject(error);
                                }
                            };
                            reader.readAsDataURL(blob);
                        })];
            }
        });
    });
}
exports.fetchAsDataURL = fetchAsDataURL;
var cache = {};
function getCacheKey(url, contentType, includeQueryParams) {
    var key = url.replace(/\?.*/, '');
    if (includeQueryParams) {
        key = url;
    }
    // font resource
    if (/ttf|otf|eot|woff2?/i.test(key)) {
        key = key.replace(/.*\//, '');
    }
    return contentType ? "[".concat(contentType, "]").concat(key) : key;
}
function resourceToDataURL(resourceUrl, contentType, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cacheKey, dataURL, content, error_1, msg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cacheKey = getCacheKey(resourceUrl, contentType, options.includeQueryParams);
                    if (cache[cacheKey] != null) {
                        return [2 /*return*/, cache[cacheKey]];
                    }
                    // ref: https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest#Bypassing_the_cache
                    if (options.cacheBust) {
                        // eslint-disable-next-line no-param-reassign
                        resourceUrl += (/\?/.test(resourceUrl) ? '&' : '?') + new Date().getTime();
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAsDataURL(resourceUrl, options.fetchRequestInit, function (_a) {
                            var res = _a.res, result = _a.result;
                            if (!contentType) {
                                // eslint-disable-next-line no-param-reassign
                                contentType = res.headers.get('Content-Type') || '';
                            }
                            return getContentFromDataUrl(result);
                        })];
                case 2:
                    content = _a.sent();
                    dataURL = makeDataUrl(content, contentType);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    dataURL = options.imagePlaceholder || '';
                    msg = "Failed to fetch resource: ".concat(resourceUrl);
                    if (error_1) {
                        msg = typeof error_1 === 'string' ? error_1 : error_1.message;
                    }
                    if (msg) {
                        console.warn(msg);
                    }
                    return [3 /*break*/, 4];
                case 4:
                    cache[cacheKey] = dataURL;
                    return [2 /*return*/, dataURL];
            }
        });
    });
}
exports.resourceToDataURL = resourceToDataURL;
//# sourceMappingURL=dataurl.js.map
},{}],7:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedImages = void 0;
var embed_resources_1 = require("./embed-resources");
var util_1 = require("./util");
var dataurl_1 = require("./dataurl");
var mimes_1 = require("./mimes");
function embedProp(propName, node, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var propValue, cssString;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    propValue = (_a = node.style) === null || _a === void 0 ? void 0 : _a.getPropertyValue(propName);
                    if (!propValue) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, embed_resources_1.embedResources)(propValue, null, options)];
                case 1:
                    cssString = _b.sent();
                    node.style.setProperty(propName, cssString, node.style.getPropertyPriority(propName));
                    return [2 /*return*/, true];
                case 2: return [2 /*return*/, false];
            }
        });
    });
}
function embedBackground(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, embedProp('background', clonedNode, options)];
                case 1:
                    if (!!(_a.sent())) return [3 /*break*/, 3];
                    return [4 /*yield*/, embedProp('background-image', clonedNode, options)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, embedProp('mask', clonedNode, options)];
                case 4:
                    if (!!(_a.sent())) return [3 /*break*/, 6];
                    return [4 /*yield*/, embedProp('mask-image', clonedNode, options)];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function embedImageNode(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var isImageElement, url, dataURL;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isImageElement = (0, util_1.isInstanceOfElement)(clonedNode, HTMLImageElement);
                    if (!(isImageElement && !(0, dataurl_1.isDataUrl)(clonedNode.src)) &&
                        !((0, util_1.isInstanceOfElement)(clonedNode, SVGImageElement) &&
                            !(0, dataurl_1.isDataUrl)(clonedNode.href.baseVal))) {
                        return [2 /*return*/];
                    }
                    url = isImageElement ? clonedNode.src : clonedNode.href.baseVal;
                    return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(url, (0, mimes_1.getMimeType)(url), options)];
                case 1:
                    dataURL = _a.sent();
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            clonedNode.onload = resolve;
                            clonedNode.onerror = options.onImageErrorHandler
                                ? function () {
                                    var attributes = [];
                                    for (var _i = 0; _i < arguments.length; _i++) {
                                        attributes[_i] = arguments[_i];
                                    }
                                    try {
                                        resolve(options.onImageErrorHandler.apply(options, attributes));
                                    }
                                    catch (error) {
                                        reject(error);
                                    }
                                }
                                : reject;
                            var image = clonedNode;
                            if (image.decode) {
                                image.decode = resolve;
                            }
                            if (image.loading === 'lazy') {
                                image.loading = 'eager';
                            }
                            if (isImageElement) {
                                clonedNode.srcset = '';
                                clonedNode.src = dataURL;
                            }
                            else {
                                clonedNode.href.baseVal = dataURL;
                            }
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function embedChildren(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var children, deferreds;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    children = (0, util_1.toArray)(clonedNode.childNodes);
                    deferreds = children.map(function (child) { return embedImages(child, options); });
                    return [4 /*yield*/, Promise.all(deferreds).then(function () { return clonedNode; })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function embedImages(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(0, util_1.isInstanceOfElement)(clonedNode, Element)) return [3 /*break*/, 4];
                    return [4 /*yield*/, embedBackground(clonedNode, options)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, embedImageNode(clonedNode, options)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, embedChildren(clonedNode, options)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.embedImages = embedImages;
//# sourceMappingURL=embed-images.js.map
},{"./dataurl":6,"./embed-resources":8,"./mimes":11,"./util":12}],8:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedResources = exports.shouldEmbed = exports.embed = exports.parseURLs = void 0;
var util_1 = require("./util");
var mimes_1 = require("./mimes");
var dataurl_1 = require("./dataurl");
var URL_REGEX = /url\((['"]?)([^'"]+?)\1\)/g;
var URL_WITH_FORMAT_REGEX = /url\([^)]+\)\s*format\((["']?)([^"']+)\1\)/g;
var FONT_SRC_REGEX = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function toRegex(url) {
    // eslint-disable-next-line no-useless-escape
    var escaped = url.replace(/([.*+?^${}()|\[\]\/\\])/g, '\\$1');
    return new RegExp("(url\\(['\"]?)(".concat(escaped, ")(['\"]?\\))"), 'g');
}
function parseURLs(cssText) {
    var urls = [];
    cssText.replace(URL_REGEX, function (raw, quotation, url) {
        urls.push(url);
        return raw;
    });
    return urls.filter(function (url) { return !(0, dataurl_1.isDataUrl)(url); });
}
exports.parseURLs = parseURLs;
function embed(cssText, resourceURL, baseURL, options, getContentFromUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var resolvedURL, contentType, dataURL, content, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    resolvedURL = baseURL ? (0, util_1.resolveUrl)(resourceURL, baseURL) : resourceURL;
                    contentType = (0, mimes_1.getMimeType)(resourceURL);
                    dataURL = void 0;
                    if (!getContentFromUrl) return [3 /*break*/, 2];
                    return [4 /*yield*/, getContentFromUrl(resolvedURL)];
                case 1:
                    content = _a.sent();
                    dataURL = (0, dataurl_1.makeDataUrl)(content, contentType);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, dataurl_1.resourceToDataURL)(resolvedURL, contentType, options)];
                case 3:
                    dataURL = _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/, cssText.replace(toRegex(resourceURL), "$1".concat(dataURL, "$3"))];
                case 5:
                    error_1 = _a.sent();
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/, cssText];
            }
        });
    });
}
exports.embed = embed;
function filterPreferredFontFormat(str, _a) {
    var preferredFontFormat = _a.preferredFontFormat;
    return !preferredFontFormat
        ? str
        : str.replace(FONT_SRC_REGEX, function (match) {
            // eslint-disable-next-line no-constant-condition
            while (true) {
                var _a = URL_WITH_FORMAT_REGEX.exec(match) || [], src = _a[0], format = _a[2];
                if (!format) {
                    return '';
                }
                if (format === preferredFontFormat) {
                    return "src: ".concat(src, ";");
                }
            }
        });
}
function shouldEmbed(url) {
    return url.search(URL_REGEX) !== -1;
}
exports.shouldEmbed = shouldEmbed;
function embedResources(cssText, baseUrl, options) {
    return __awaiter(this, void 0, void 0, function () {
        var filteredCSSText, urls;
        return __generator(this, function (_a) {
            if (!shouldEmbed(cssText)) {
                return [2 /*return*/, cssText];
            }
            filteredCSSText = filterPreferredFontFormat(cssText, options);
            urls = parseURLs(filteredCSSText);
            return [2 /*return*/, urls.reduce(function (deferred, url) {
                    return deferred.then(function (css) { return embed(css, url, baseUrl, options); });
                }, Promise.resolve(filteredCSSText))];
        });
    });
}
exports.embedResources = embedResources;
//# sourceMappingURL=embed-resources.js.map
},{"./dataurl":6,"./mimes":11,"./util":12}],9:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedWebFonts = exports.getWebFontCSS = void 0;
var util_1 = require("./util");
var dataurl_1 = require("./dataurl");
var embed_resources_1 = require("./embed-resources");
var cssFetchCache = {};
function fetchCSS(url) {
    return __awaiter(this, void 0, void 0, function () {
        var cache, res, cssText;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cache = cssFetchCache[url];
                    if (cache != null) {
                        return [2 /*return*/, cache];
                    }
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    res = _a.sent();
                    return [4 /*yield*/, res.text()];
                case 2:
                    cssText = _a.sent();
                    cache = { url: url, cssText: cssText };
                    cssFetchCache[url] = cache;
                    return [2 /*return*/, cache];
            }
        });
    });
}
function embedFonts(data, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cssText, regexUrl, fontLocs, loadFonts;
        var _this = this;
        return __generator(this, function (_a) {
            cssText = data.cssText;
            regexUrl = /url\(["']?([^"')]+)["']?\)/g;
            fontLocs = cssText.match(/url\([^)]+\)/g) || [];
            loadFonts = fontLocs.map(function (loc) { return __awaiter(_this, void 0, void 0, function () {
                var url;
                return __generator(this, function (_a) {
                    url = loc.replace(regexUrl, '$1');
                    if (!url.startsWith('https://')) {
                        url = new URL(url, data.url).href;
                    }
                    return [2 /*return*/, (0, dataurl_1.fetchAsDataURL)(url, options.fetchRequestInit, function (_a) {
                            var result = _a.result;
                            cssText = cssText.replace(loc, "url(".concat(result, ")"));
                            return [loc, result];
                        })];
                });
            }); });
            return [2 /*return*/, Promise.all(loadFonts).then(function () { return cssText; })];
        });
    });
}
function parseCSS(source) {
    if (source == null) {
        return [];
    }
    var result = [];
    var commentsRegex = /(\/\*[\s\S]*?\*\/)/gi;
    // strip out comments
    var cssText = source.replace(commentsRegex, '');
    // eslint-disable-next-line prefer-regex-literals
    var keyframesRegex = new RegExp('((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})', 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var matches = keyframesRegex.exec(cssText);
        if (matches === null) {
            break;
        }
        result.push(matches[0]);
    }
    cssText = cssText.replace(keyframesRegex, '');
    var importRegex = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi;
    // to match css & media queries together
    var combinedCSSRegex = '((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]' +
        '*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})';
    // unified regex
    var unifiedRegex = new RegExp(combinedCSSRegex, 'gi');
    // eslint-disable-next-line no-constant-condition
    while (true) {
        var matches = importRegex.exec(cssText);
        if (matches === null) {
            matches = unifiedRegex.exec(cssText);
            if (matches === null) {
                break;
            }
            else {
                importRegex.lastIndex = unifiedRegex.lastIndex;
            }
        }
        else {
            unifiedRegex.lastIndex = importRegex.lastIndex;
        }
        result.push(matches[0]);
    }
    return result;
}
function getCSSRules(styleSheets, options) {
    return __awaiter(this, void 0, void 0, function () {
        var ret, deferreds;
        return __generator(this, function (_a) {
            ret = [];
            deferreds = [];
            // First loop inlines imports
            styleSheets.forEach(function (sheet) {
                if ('cssRules' in sheet) {
                    try {
                        (0, util_1.toArray)(sheet.cssRules || []).forEach(function (item, index) {
                            if (item.type === CSSRule.IMPORT_RULE) {
                                var importIndex_1 = index + 1;
                                var url = item.href;
                                var deferred = fetchCSS(url)
                                    .then(function (metadata) { return embedFonts(metadata, options); })
                                    .then(function (cssText) {
                                    return parseCSS(cssText).forEach(function (rule) {
                                        try {
                                            sheet.insertRule(rule, rule.startsWith('@import')
                                                ? (importIndex_1 += 1)
                                                : sheet.cssRules.length);
                                        }
                                        catch (error) {
                                            console.error('Error inserting rule from remote css', {
                                                rule: rule,
                                                error: error,
                                            });
                                        }
                                    });
                                })
                                    .catch(function (e) {
                                    console.error('Error loading remote css', e.toString());
                                });
                                deferreds.push(deferred);
                            }
                        });
                    }
                    catch (e) {
                        var inline_1 = styleSheets.find(function (a) { return a.href == null; }) || document.styleSheets[0];
                        if (sheet.href != null) {
                            deferreds.push(fetchCSS(sheet.href)
                                .then(function (metadata) { return embedFonts(metadata, options); })
                                .then(function (cssText) {
                                return parseCSS(cssText).forEach(function (rule) {
                                    inline_1.insertRule(rule, sheet.cssRules.length);
                                });
                            })
                                .catch(function (err) {
                                console.error('Error loading remote stylesheet', err);
                            }));
                        }
                        console.error('Error inlining remote css file', e);
                    }
                }
            });
            return [2 /*return*/, Promise.all(deferreds).then(function () {
                    // Second loop parses rules
                    styleSheets.forEach(function (sheet) {
                        if ('cssRules' in sheet) {
                            try {
                                (0, util_1.toArray)(sheet.cssRules || []).forEach(function (item) {
                                    ret.push(item);
                                });
                            }
                            catch (e) {
                                console.error("Error while reading CSS rules from ".concat(sheet.href), e);
                            }
                        }
                    });
                    return ret;
                })];
        });
    });
}
function getWebFontRules(cssRules) {
    return cssRules
        .filter(function (rule) { return rule.type === CSSRule.FONT_FACE_RULE; })
        .filter(function (rule) { return (0, embed_resources_1.shouldEmbed)(rule.style.getPropertyValue('src')); });
}
function parseWebFontRules(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        var styleSheets, cssRules;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (node.ownerDocument == null) {
                        throw new Error('Provided element is not within a Document');
                    }
                    styleSheets = (0, util_1.toArray)(node.ownerDocument.styleSheets);
                    return [4 /*yield*/, getCSSRules(styleSheets, options)];
                case 1:
                    cssRules = _a.sent();
                    return [2 /*return*/, getWebFontRules(cssRules)];
            }
        });
    });
}
function normalizeFontFamily(font) {
    return font.trim().replace(/["']/g, '');
}
function getUsedFonts(node) {
    var fonts = new Set();
    function traverse(node) {
        var fontFamily = node.style.fontFamily || getComputedStyle(node).fontFamily;
        fontFamily.split(',').forEach(function (font) {
            fonts.add(normalizeFontFamily(font));
        });
        Array.from(node.children).forEach(function (child) {
            if (child instanceof HTMLElement) {
                traverse(child);
            }
        });
    }
    traverse(node);
    return fonts;
}
function getWebFontCSS(node, options) {
    return __awaiter(this, void 0, void 0, function () {
        var rules, usedFonts, cssTexts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseWebFontRules(node, options)];
                case 1:
                    rules = _a.sent();
                    usedFonts = getUsedFonts(node);
                    return [4 /*yield*/, Promise.all(rules
                            .filter(function (rule) {
                            return usedFonts.has(normalizeFontFamily(rule.style.fontFamily));
                        })
                            .map(function (rule) {
                            var baseUrl = rule.parentStyleSheet
                                ? rule.parentStyleSheet.href
                                : null;
                            return (0, embed_resources_1.embedResources)(rule.cssText, baseUrl, options);
                        }))];
                case 2:
                    cssTexts = _a.sent();
                    return [2 /*return*/, cssTexts.join('\n')];
            }
        });
    });
}
exports.getWebFontCSS = getWebFontCSS;
function embedWebFonts(clonedNode, options) {
    return __awaiter(this, void 0, void 0, function () {
        var cssText, _a, _b, styleNode, sytleContent;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(options.fontEmbedCSS != null)) return [3 /*break*/, 1];
                    _a = options.fontEmbedCSS;
                    return [3 /*break*/, 5];
                case 1:
                    if (!options.skipFonts) return [3 /*break*/, 2];
                    _b = null;
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, getWebFontCSS(clonedNode, options)];
                case 3:
                    _b = _c.sent();
                    _c.label = 4;
                case 4:
                    _a = _b;
                    _c.label = 5;
                case 5:
                    cssText = _a;
                    if (cssText) {
                        styleNode = document.createElement('style');
                        sytleContent = document.createTextNode(cssText);
                        styleNode.appendChild(sytleContent);
                        if (clonedNode.firstChild) {
                            clonedNode.insertBefore(styleNode, clonedNode.firstChild);
                        }
                        else {
                            clonedNode.appendChild(styleNode);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
exports.embedWebFonts = embedWebFonts;
//# sourceMappingURL=embed-webfonts.js.map
},{"./dataurl":6,"./embed-resources":8,"./util":12}],10:[function(require,module,exports){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontEmbedCSS = exports.toBlob = exports.toJpeg = exports.toPng = exports.toPixelData = exports.toCanvas = exports.toSvg = void 0;
var clone_node_1 = require("./clone-node");
var embed_images_1 = require("./embed-images");
var apply_style_1 = require("./apply-style");
var embed_webfonts_1 = require("./embed-webfonts");
var util_1 = require("./util");
function toSvg(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, clonedNode, datauri;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, (0, clone_node_1.cloneNode)(node, options, true)];
                case 1:
                    clonedNode = (_b.sent());
                    return [4 /*yield*/, (0, embed_webfonts_1.embedWebFonts)(clonedNode, options)];
                case 2:
                    _b.sent();
                    return [4 /*yield*/, (0, embed_images_1.embedImages)(clonedNode, options)];
                case 3:
                    _b.sent();
                    (0, apply_style_1.applyStyle)(clonedNode, options);
                    return [4 /*yield*/, (0, util_1.nodeToDataURL)(clonedNode, width, height)];
                case 4:
                    datauri = _b.sent();
                    return [2 /*return*/, datauri];
            }
        });
    });
}
exports.toSvg = toSvg;
function toCanvas(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, svg, img, canvas, context, ratio, canvasWidth, canvasHeight;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, toSvg(node, options)];
                case 1:
                    svg = _b.sent();
                    return [4 /*yield*/, (0, util_1.createImage)(svg)];
                case 2:
                    img = _b.sent();
                    canvas = document.createElement('canvas');
                    context = canvas.getContext('2d');
                    ratio = options.pixelRatio || (0, util_1.getPixelRatio)();
                    canvasWidth = options.canvasWidth || width;
                    canvasHeight = options.canvasHeight || height;
                    canvas.width = canvasWidth * ratio;
                    canvas.height = canvasHeight * ratio;
                    if (!options.skipAutoScale) {
                        (0, util_1.checkCanvasDimensions)(canvas);
                    }
                    canvas.style.width = "".concat(canvasWidth);
                    canvas.style.height = "".concat(canvasHeight);
                    if (options.backgroundColor) {
                        context.fillStyle = options.backgroundColor;
                        context.fillRect(0, 0, canvas.width, canvas.height);
                    }
                    context.drawImage(img, 0, 0, canvas.width, canvas.height);
                    return [2 /*return*/, canvas];
            }
        });
    });
}
exports.toCanvas = toCanvas;
function toPixelData(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, width, height, canvas, ctx;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = (0, util_1.getImageSize)(node, options), width = _a.width, height = _a.height;
                    return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _b.sent();
                    ctx = canvas.getContext('2d');
                    return [2 /*return*/, ctx.getImageData(0, 0, width, height).data];
            }
        });
    });
}
exports.toPixelData = toPixelData;
function toPng(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [2 /*return*/, canvas.toDataURL()];
            }
        });
    });
}
exports.toPng = toPng;
function toJpeg(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [2 /*return*/, canvas.toDataURL('image/jpeg', options.quality || 1)];
            }
        });
    });
}
exports.toJpeg = toJpeg;
function toBlob(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var canvas, blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, toCanvas(node, options)];
                case 1:
                    canvas = _a.sent();
                    return [4 /*yield*/, (0, util_1.canvasToBlob)(canvas)];
                case 2:
                    blob = _a.sent();
                    return [2 /*return*/, blob];
            }
        });
    });
}
exports.toBlob = toBlob;
function getFontEmbedCSS(node, options) {
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, (0, embed_webfonts_1.getWebFontCSS)(node, options)];
        });
    });
}
exports.getFontEmbedCSS = getFontEmbedCSS;
//# sourceMappingURL=index.js.map
},{"./apply-style":3,"./clone-node":4,"./embed-images":7,"./embed-webfonts":9,"./util":12}],11:[function(require,module,exports){
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMimeType = void 0;
var WOFF = 'application/font-woff';
var JPEG = 'image/jpeg';
var mimes = {
    woff: WOFF,
    woff2: WOFF,
    ttf: 'application/font-truetype',
    eot: 'application/vnd.ms-fontobject',
    png: 'image/png',
    jpg: JPEG,
    jpeg: JPEG,
    gif: 'image/gif',
    tiff: 'image/tiff',
    svg: 'image/svg+xml',
    webp: 'image/webp',
};
function getExtension(url) {
    var match = /\.([^./]*?)$/g.exec(url);
    return match ? match[1] : '';
}
function getMimeType(url) {
    var extension = getExtension(url).toLowerCase();
    return mimes[extension] || '';
}
exports.getMimeType = getMimeType;
//# sourceMappingURL=mimes.js.map
},{}],12:[function(require,module,exports){
(function (process){
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstanceOfElement = exports.nodeToDataURL = exports.svgToDataURL = exports.createImage = exports.canvasToBlob = exports.checkCanvasDimensions = exports.getPixelRatio = exports.getImageSize = exports.toArray = exports.delay = exports.uuid = exports.resolveUrl = void 0;
function resolveUrl(url, baseUrl) {
    // url is absolute already
    if (url.match(/^[a-z]+:\/\//i)) {
        return url;
    }
    // url is absolute already, without protocol
    if (url.match(/^\/\//)) {
        return window.location.protocol + url;
    }
    // dataURI, mailto:, tel:, etc.
    if (url.match(/^[a-z]+:/i)) {
        return url;
    }
    var doc = document.implementation.createHTMLDocument();
    var base = doc.createElement('base');
    var a = doc.createElement('a');
    doc.head.appendChild(base);
    doc.body.appendChild(a);
    if (baseUrl) {
        base.href = baseUrl;
    }
    a.href = url;
    return a.href;
}
exports.resolveUrl = resolveUrl;
exports.uuid = (function () {
    // generate uuid for className of pseudo elements.
    // We should not use GUIDs, otherwise pseudo elements sometimes cannot be captured.
    var counter = 0;
    // ref: http://stackoverflow.com/a/6248722/2519373
    var random = function () {
        // eslint-disable-next-line no-bitwise
        return "0000".concat(((Math.random() * Math.pow(36, 4)) << 0).toString(36)).slice(-4);
    };
    return function () {
        counter += 1;
        return "u".concat(random()).concat(counter);
    };
})();
function delay(ms) {
    return function (args) {
        return new Promise(function (resolve) {
            setTimeout(function () { return resolve(args); }, ms);
        });
    };
}
exports.delay = delay;
function toArray(arrayLike) {
    var arr = [];
    for (var i = 0, l = arrayLike.length; i < l; i++) {
        arr.push(arrayLike[i]);
    }
    return arr;
}
exports.toArray = toArray;
function px(node, styleProperty) {
    var win = node.ownerDocument.defaultView || window;
    var val = win.getComputedStyle(node).getPropertyValue(styleProperty);
    return val ? parseFloat(val.replace('px', '')) : 0;
}
function getNodeWidth(node) {
    var leftBorder = px(node, 'border-left-width');
    var rightBorder = px(node, 'border-right-width');
    return node.clientWidth + leftBorder + rightBorder;
}
function getNodeHeight(node) {
    var topBorder = px(node, 'border-top-width');
    var bottomBorder = px(node, 'border-bottom-width');
    return node.clientHeight + topBorder + bottomBorder;
}
function getImageSize(targetNode, options) {
    if (options === void 0) { options = {}; }
    var width = options.width || getNodeWidth(targetNode);
    var height = options.height || getNodeHeight(targetNode);
    return { width: width, height: height };
}
exports.getImageSize = getImageSize;
function getPixelRatio() {
    var ratio;
    var FINAL_PROCESS;
    try {
        FINAL_PROCESS = process;
    }
    catch (e) {
        // pass
    }
    var val = FINAL_PROCESS && FINAL_PROCESS.env
        ? FINAL_PROCESS.env.devicePixelRatio
        : null;
    if (val) {
        ratio = parseInt(val, 10);
        if (Number.isNaN(ratio)) {
            ratio = 1;
        }
    }
    return ratio || window.devicePixelRatio || 1;
}
exports.getPixelRatio = getPixelRatio;
// @see https://developer.mozilla.org/en-US/docs/Web/HTML/Element/canvas#maximum_canvas_size
var canvasDimensionLimit = 16384;
function checkCanvasDimensions(canvas) {
    if (canvas.width > canvasDimensionLimit ||
        canvas.height > canvasDimensionLimit) {
        if (canvas.width > canvasDimensionLimit &&
            canvas.height > canvasDimensionLimit) {
            if (canvas.width > canvas.height) {
                canvas.height *= canvasDimensionLimit / canvas.width;
                canvas.width = canvasDimensionLimit;
            }
            else {
                canvas.width *= canvasDimensionLimit / canvas.height;
                canvas.height = canvasDimensionLimit;
            }
        }
        else if (canvas.width > canvasDimensionLimit) {
            canvas.height *= canvasDimensionLimit / canvas.width;
            canvas.width = canvasDimensionLimit;
        }
        else {
            canvas.width *= canvasDimensionLimit / canvas.height;
            canvas.height = canvasDimensionLimit;
        }
    }
}
exports.checkCanvasDimensions = checkCanvasDimensions;
function canvasToBlob(canvas, options) {
    if (options === void 0) { options = {}; }
    if (canvas.toBlob) {
        return new Promise(function (resolve) {
            canvas.toBlob(resolve, options.type ? options.type : 'image/png', options.quality ? options.quality : 1);
        });
    }
    return new Promise(function (resolve) {
        var binaryString = window.atob(canvas
            .toDataURL(options.type ? options.type : undefined, options.quality ? options.quality : undefined)
            .split(',')[1]);
        var len = binaryString.length;
        var binaryArray = new Uint8Array(len);
        for (var i = 0; i < len; i += 1) {
            binaryArray[i] = binaryString.charCodeAt(i);
        }
        resolve(new Blob([binaryArray], {
            type: options.type ? options.type : 'image/png',
        }));
    });
}
exports.canvasToBlob = canvasToBlob;
function createImage(url) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
            img.decode().then(function () {
                requestAnimationFrame(function () { return resolve(img); });
            });
        };
        img.onerror = reject;
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.src = url;
    });
}
exports.createImage = createImage;
function svgToDataURL(svg) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve()
                    .then(function () { return new XMLSerializer().serializeToString(svg); })
                    .then(encodeURIComponent)
                    .then(function (html) { return "data:image/svg+xml;charset=utf-8,".concat(html); })];
        });
    });
}
exports.svgToDataURL = svgToDataURL;
function nodeToDataURL(node, width, height) {
    return __awaiter(this, void 0, void 0, function () {
        var xmlns, svg, foreignObject;
        return __generator(this, function (_a) {
            xmlns = 'http://www.w3.org/2000/svg';
            svg = document.createElementNS(xmlns, 'svg');
            foreignObject = document.createElementNS(xmlns, 'foreignObject');
            svg.setAttribute('width', "".concat(width));
            svg.setAttribute('height', "".concat(height));
            svg.setAttribute('viewBox', "0 0 ".concat(width, " ").concat(height));
            foreignObject.setAttribute('width', '100%');
            foreignObject.setAttribute('height', '100%');
            foreignObject.setAttribute('x', '0');
            foreignObject.setAttribute('y', '0');
            foreignObject.setAttribute('externalResourcesRequired', 'true');
            svg.appendChild(foreignObject);
            foreignObject.appendChild(node);
            return [2 /*return*/, svgToDataURL(svg)];
        });
    });
}
exports.nodeToDataURL = nodeToDataURL;
var isInstanceOfElement = function (node, instance) {
    if (node instanceof instance)
        return true;
    var nodePrototype = Object.getPrototypeOf(node);
    if (nodePrototype === null)
        return false;
    return (nodePrototype.constructor.name === instance.name ||
        (0, exports.isInstanceOfElement)(nodePrototype, instance));
};
exports.isInstanceOfElement = isInstanceOfElement;
//# sourceMappingURL=util.js.map
}).call(this,require("Wb8Gej"))
},{"Wb8Gej":2}]},{},[1])